// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback p.small{
  font-size: 12px;
}

.feedback .feedback-form .normal-box button{
  margin-bottom:8px;
  margin-right: 8px;
}

.feedback .feedback-form label {
  color: #818181;
  position: absolute;
  padding: 10px;
  font-size: 12px;
  z-index: 1;
}

.feedback .feedback-form textarea {
  padding-top: 1.825rem;
}

.use-app button{
  font-size: 14px;
  padding: 5px 10px;
}

.feedback-form .normal-box{
  width: 100%;
  white-space: normal;
}

.normal-box .rating-star span{
  display: inline-block;
}

.serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info:hover,
.serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info.active{
  color: #fff;
  border: 1px solid transparent;
}

/* .serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info.active{
  background-color: #009fdc;
} */

.rating-star{
  display: flex;
  align-items: center;
}

.rating-symbol .star{
  font-size: 24px;
}

.rating-symbol .star-count{
  margin-left: 10px;
}

.rating-symbol>div{
  display: flex;
  align-items: center;
}

.rating-symbol span.star-count{
  background-color: #af1e25;
  color: #fff;
  width: 30px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  padding: 0 5px;
}

`, "",{"version":3,"sources":["webpack://./src/components/Feedback.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".feedback p.small{\r\n  font-size: 12px;\r\n}\r\n\r\n.feedback .feedback-form .normal-box button{\r\n  margin-bottom:8px;\r\n  margin-right: 8px;\r\n}\r\n\r\n.feedback .feedback-form label {\r\n  color: #818181;\r\n  position: absolute;\r\n  padding: 10px;\r\n  font-size: 12px;\r\n  z-index: 1;\r\n}\r\n\r\n.feedback .feedback-form textarea {\r\n  padding-top: 1.825rem;\r\n}\r\n\r\n.use-app button{\r\n  font-size: 14px;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.feedback-form .normal-box{\r\n  width: 100%;\r\n  white-space: normal;\r\n}\r\n\r\n.normal-box .rating-star span{\r\n  display: inline-block;\r\n}\r\n\r\n.serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info:hover,\r\n.serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info.active{\r\n  color: #fff;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n/* .serviceplace-container-class .feedback .normal-box .use-app .btn-outline-info.active{\r\n  background-color: #009fdc;\r\n} */\r\n\r\n.rating-star{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.rating-symbol .star{\r\n  font-size: 24px;\r\n}\r\n\r\n.rating-symbol .star-count{\r\n  margin-left: 10px;\r\n}\r\n\r\n.rating-symbol>div{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.rating-symbol span.star-count{\r\n  background-color: #af1e25;\r\n  color: #fff;\r\n  width: 30px;\r\n  height: 20px;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  padding: 0 5px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
